// extracted by mini-css-extract-plugin
export var editButton = "_ov-0";